import { useDispatch, useSelector } from "react-redux";
import { reportChartPercentage } from "../store/report";

export default function useReport() {
  const dispatch = useDispatch();

  const reportChartPercentageData = useSelector((state) => state.report.data);
  const loading = useSelector((state) => state.report.loading);
console.log(reportChartPercentageData,"reportChartPercentageData");
  const reportChartPercentageAction = (params) => dispatch(reportChartPercentage(params));

  return {
    reportChartPercentageData,
    reportChartPercentageAction,
    loading,
  };
}
